import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GarageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"garage"}/>
}
